import axiosConfig from "./axiosConfig";

export interface RegisterSoracomSimRequest {
  imsi: string;
  registration_secret: string;
}

export interface RegisterSoracomSimResponse {
  subscriber: Record<string, unknown>;
}

const postRegisterSoracomSim = async (
  authToken: string,
  siteId: string,
  esysUuid: string,
  request: RegisterSoracomSimRequest
): Promise<RegisterSoracomSimResponse> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/ingestion/soracom/register_sim`,
    request,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      params: { esysUuid },
    }
  );
  return data;
};

export default postRegisterSoracomSim;
